export default {
  'menu.membership': '会员与权益',
  'pages.membership.action.addItem': '添加项',
  'pages.membership.action.column': '操作',
  'pages.membership.action.detail': '详情',
  'pages.membership.action.edit': '编辑',
  'pages.membership.action.editLevel': '编辑等级',
  'pages.membership.action.query': '查询',
  'pages.membership.action.refresh': '刷新',
  'pages.membership.action.submit': '提交',
  'pages.membership.action.unverify': '取消认证',
  'pages.membership.action.verify': '设置认证',
  'pages.membership.drawer.levelDetail': '等级详情',
  'pages.membership.empty.data': '暂无数据',
  'pages.membership.empty.result': '暂无操作结果',
  'pages.membership.entitlement.checkType': '校验类型',
  'pages.membership.entitlement.key': '权益键',
  'pages.membership.entitlement.resetCycle': '重置周期',
  'pages.membership.entitlement.unit': '单位',
  'pages.membership.entitlement.value': '权益值',
  'pages.membership.level.code': '等级编码',
  'pages.membership.level.description': '描述',
  'pages.membership.level.levelId': '等级 ID',
  'pages.membership.level.name': '等级名称',
  'pages.membership.level.sortOrder': '排序',
  'pages.membership.level.status': '状态',
  'pages.membership.message.entitlementMissing': '缺少权益键',
  'pages.membership.message.saved': '已保存',
  'pages.membership.message.userIdRequired': '请输入用户 ID',
  'pages.membership.modal.editEntitlement': '编辑权益',
  'pages.membership.modal.editLevel': '编辑等级',
  'pages.membership.section.entitlements': '等级权益',
  'pages.membership.section.levelDefinition': '等级定义',
  'pages.membership.tab.levels': '等级与权益',
  'pages.membership.tab.usage': '额度操作',
  'pages.membership.tab.users': '用户会员',
  'pages.membership.title': '会员与权益',
  'pages.membership.usage.adjust': '调整额度',
  'pages.membership.usage.bizId': '业务 ID',
  'pages.membership.usage.bizType': '业务类型',
  'pages.membership.usage.check': '校验额度',
  'pages.membership.usage.deduct': '扣减额度',
  'pages.membership.usage.deductValue': '扣减值',
  'pages.membership.usage.delta': '调整值',
  'pages.membership.usage.nextResetAt': '下次重置时间',
  'pages.membership.usage.reason': '原因',
  'pages.membership.usage.refill': '回补额度',
  'pages.membership.usage.remaining': '剩余额度',
  'pages.membership.usage.requiredValue': '所需额度',
  'pages.membership.usage.result': '操作结果',
  'pages.membership.usage.scope': '范围',
  'pages.membership.usage.total': '总额度',
  'pages.membership.usage.trigger': '触发来源',
  'pages.membership.usage.triggerRef': '触发引用',
  'pages.membership.user.changeType': '变更类型',
  'pages.membership.user.createdAt': '创建时间',
  'pages.membership.user.currentLevel': '当前等级',
  'pages.membership.user.durationDays': '有效天数',
  'pages.membership.user.fromLevel': '原等级',
  'pages.membership.user.levelHistory': '等级变更历史',
  'pages.membership.user.setLevel': '设置用户等级',
  'pages.membership.user.source': '来源',
  'pages.membership.user.sourceRef': '来源引用',
  'pages.membership.user.toLevel': '目标等级',
  'pages.membership.user.twitterUrl': 'Twitter URL',
  'pages.membership.user.usageSummary': '额度汇总',
  'pages.membership.user.userId': '用户 ID',
  'pages.membership.user.verifyAction': '用户认证',
  'pages.membership.user.verifyStatus': '认证状态',
};
